import { Component, input, output } from '@angular/core';
import { TTranslationKey } from 'src/app/project/features/translate/types';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { autosizeTextArea } from 'src/app/project/shared/utils/autosize-text-area';

@Component({
  selector: 'pp-custom-field-description-input',
  templateUrl: './custom-field-description-input.component.html',
  styleUrl: './custom-field-description-input.component.scss',
  standalone: false,
})
export class CustomFieldDescriptionInputComponent {
  ppDescription = input<string>();
  ppDescriptionChange = output<string>();
  ppPlaceholder = input<TTranslationKey | null>('custom_field_description_input_placeholder');

  focused = false;
  EIconPath = EIconPath;

  onInputFocus(): void {
    this.focused = true;
  }

  onInputFocusLost(): void {
    this.focused = false;
  }

  blurInput(event: Event): void {
    (event.target as HTMLElement).blur();
  }

  clearDescription(): void {
    this.ppDescriptionChange.emit('');
  }

  onInput(event: Event): void {
    const element = event.target as HTMLElement;

    autosizeTextArea(element);
  }
}
